import { useUniversalAuth } from "@wtc/ui";

// Utility function for making authenticated API calls to QuickBooks endpoints
export const useAuthenticatedFetch = () => {
  const { session } = useUniversalAuth();

  return (url: string, options: RequestInit = {}) => {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string>),
    };

    if (session?.access_token) {
      headers.Authorization = `Bearer ${session.access_token}`;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  };
};

// Simple helper for authenticated QuickBooks API calls
export const makeAuthenticatedQuickBooksCall = async (
  endpoint: string,
  body: any,
  authToken?: string
) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  const response = await fetch(`/api/quickbooks/${endpoint}`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `Failed to call ${endpoint}`);
  }

  return response.json();
};

// Authenticated GET helper for QuickBooks API routes (no body)
export const makeAuthenticatedQuickBooksGet = async (endpoint: string, authToken?: string) => {
  const headers: Record<string, string> = {};
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }
  const response = await fetch(`/api/quickbooks/${endpoint}`, {
    method: "GET",
    headers,
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `Failed to call ${endpoint}`);
  }
  return response.json();
};
